export const STYTCH_PUBLIC_TOKEN = process.env.REACT_APP_STYTCH_PUBLIC_TOKEN;

export const STYTCH_REDIRECT_URL = process.env.REACT_APP_STYTCH_REDIRECT_URL;

export const GLOBAL = {
  TOKEN_KEY: "@ADMIN_SOMOS_TOKEN",
  USER_INFO: "@ADMIN_SOMOS_USER_INFO",
};
